module.exports = __webpack_public_path__ + "media/images/icon/previous-arrow-58edcade4cb1c49802b043ddf066e6e8.svg";